import React, { Component } from "react";

import { Row, Col, Card, CardBody, FormGroup, Button,  Label, Input, Container, Spinner, Modal, ModalHeader, ModalBody, Table } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { validateToken, has_Permission } from '../../../helpers/jwt-token-access/accessToken'
import Select from "react-select";
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import Dropzone from "react-dropzone";
import SweetAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";
import { isEmpty } from "lodash";
//Import Breadcrumb
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import { BaseUrl } from "../../../helpers/Baseurl"
import ActivityLog from "./ActivityLog";

import axios from "axios";

const FuelGroup = [
	{ 
		label: "Vehical Type",
		options: [
			      { label: "Petrol", value: "Petrol" },
            { label: "Diesel", value: "Diesel" },
            { label: "CNG", value: "CNG" },
            { label: "Bio-Diesel", value: "Bio-Diesel" },
            { label: "LPG", value: "LPG" },
            { label: "Ethanol or Methanol", value: "Ethanol or Methanol" },
            { label: "Electric", value: "Electric" },			
		]
	}
];

class EditVehicles extends Component {
  constructor(props) {
    super(props);
    this.obj = JSON.parse(localStorage.getItem("authUser"))
    if (!this.obj){
        this.props.history.push('/logout')
    }else if (!validateToken(this.obj.access)){
        this.props.history.push('/logout')
    }
    if(!has_Permission(this.obj.user, 2, 'edit' )){
      this.props.history.push('/vehicles')
    }
    this.state = {
      gallery_loading:false,
      alert_confirm : false,
      success_confirm : false,
      dynamic_title: "",
			dynamic_description: "",
      image_id:"",
      package_id:"",
      default_image: null,
      vehicle:"",
      loading: false,
      brandloding:false,
      typeloading:false,
      addpackagePriceloading:false,
      editPackageloading:false,
      breadcrumbItems: [],
      model_brand: false,
      model_type: false,
      model_editPackage: false,
      model_addPackage:false,
      model_package:false,
      selectedEditPackege:[],

      selectedLocation: {},
      LocationGroup:[],
      selectedDestination:{},
      DestinationGroup:[],
      PackageGroup:[],
      SelectedPackage:{label: 'Select Packege', value: ""},
      selectedFiles:[],
      rejectedFiles:[],
      prices:[],
      description:"",
      selectedType: "",
      selectedFuel: {},
      selectedBrandsGroup: "",
      brandGroup :""
      
    };
    toastr.options = {
      positionClass: "toast-top-right",
      closeButton: "true",
      progressBar: "true",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000,
      extendedTimeOut: 1000
  }
	
    this.onPlaceInputChange = this.onPlaceInputChange.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleImageSubmit = this.handleImageSubmit.bind(this);
    this.handleDefaultImage = this.handleDefaultImage.bind(this);
    this.handleAddImageNameSubmit = this.handleAddImageNameSubmit.bind(this)
    this.handleBrandSubmit = this.handleBrandSubmit.bind(this);
    this.handleEditPackegePrice = this.handleEditPackegePrice.bind(this);
    this.handlePackegPriceSubmit = this.handlePackegPriceSubmit.bind(this);
    this.handleEditPackegeSubmit = this.handleEditPackegeSubmit.bind(this);
    this.handleVehicleTypeSubmit = this.handleVehicleTypeSubmit.bind(this);
    this.handleSelectbrandGroup = this.handleSelectbrandGroup.bind(this);
    this.handleselectedTypeGroup = this.handleselectedTypeGroup.bind(this);
    this.handleselectedFuelGroup = this.handleselectedFuelGroup.bind(this);
    this.handleSelectlocation = this.handleSelectlocation.bind(this);
    this.handleSelectDestinationGroup = this.handleSelectDestinationGroup.bind(this);
    this.handleSelectedPackageGroup = this.handleSelectedPackageGroup.bind(this);
    this.handlePackegeTypeSubmit = this.handlePackegeTypeSubmit.bind(this);
    this.tog_center = this.tog_center.bind(this);
    this.tog_images = this.tog_images.bind(this);
    this.tog_type = this.tog_type.bind(this);
    this.tog_editPackege = this.tog_editPackege.bind(this);
    this.tog_addPackege = this.tog_addPackege.bind(this);
    this.tog_package = this.tog_package.bind(this);
    this.tog_img_name = this.tog_img_name.bind(this);
    
  }
  componentDidCatch(error) {
    // Changing the state to true
    // if some error occurs
    console.log(error)
    toastr.error("Something Went Wrong", "")
    this.props.history.push('/vehicles')
  }

  tog_images() {
    this.setState(prevState => ({
      model_images: !prevState.model_images
    }));
    this.removeBodyCss();
  }
  tog_package() {
    this.setState(prevState => ({
      model_package: !prevState.model_package
    }));
    this.removeBodyCss();
  }

  tog_center() {
    this.setState(prevState => ({
      model_brand: !prevState.model_brand
    }));
    this.removeBodyCss();
  }
  tog_editPackege() {
    this.setState(prevState => ({
      model_editPackage: !prevState.model_editPackage
    }));
    this.removeBodyCss();
  }
  tog_addPackege() {
    this.setState(prevState => ({
      model_addPackage: !prevState.model_addPackage
    }));
    this.removeBodyCss();
  }
  tog_type() {
    this.setState(prevState => ({
      model_type: !prevState.model_type
    }));
    this.removeBodyCss();
  }

  tog_img_name() {
    this.setState(prevState => ({
      model_img_name: !prevState.model_img_name
    }));
    this.removeBodyCss();
  }

  removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  async componentDidMount() {
    this.loadData()
    this.loadBrandData();
    this.loadVehicleTypeData()
    this.loadDestinationData('?parent=null')
 }

 loadData(){
  const id =this.props.match.params.id
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
  };
  fetch(`${BaseUrl}/api/vehicles/vehicle/${id}/`,requestOptions)
      .then(res => res.json())
      .then(
          (data) => {  
              document.title = "Edit "+data.vehicle.name+" | Planmans";
              let breadcrumbItems= [
                  { title: "Vehicles", link: "/vehicles" },
                  { title: `${data.vehicle.name}`, link: `/vehicle/${data.vehicle.id}` },
                  { title: `Edit ${data.vehicle.name} detail`, link: "#" },
                ]  
              let selectedFuel = { label: data.vehicle.fuel_type, value: data.vehicle.fuel_type }     
              let selectedBrandsGroup = { label: data.vehicle.brand.name, value: data.vehicle.brand.id }
              let selectedType = { label: data.vehicle.vehicle_type.name, value: data.vehicle.vehicle_type.id }
              let selectedLocation = { label: data.vehicle.place.name, value: data.vehicle.place.id }
              let selectedDestination = { }
              let default_image = null
              for(let i=0; i< data.vehicle.images.length; i++){
                if (data.vehicle.images[i].is_default){
                  default_image = data.vehicle.images[i]
                }
              }
              if(data.vehicle.destination){
                selectedDestination = { label: data.vehicle.destination.name, value: data.vehicle.destination.id }
                this.loadPlacesData(`?parent__id=${data.vehicle.destination.id}`)
              }
              this.loadPackageTypeData()
              this.setState({ vehicle:data.vehicle, 
                prices:data.pricing,
                breadcrumbItems:breadcrumbItems,
                selectedFuel:selectedFuel,
                selectedBrandsGroup:selectedBrandsGroup,
                selectedType:selectedType,
                selectedLocation:selectedLocation,
                selectedDestination:selectedDestination,
                default_image:default_image,
                gallery_loading:false,
                model_img_name:false,
                imagenameloading:false  })    
             
          },
          (error) => {
              console.log(error, 'error--------------') 
          }
      ) 
}

async loadDestinationData(filer_queryset){

  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
  };
  await fetch(`${BaseUrl}/api/locations/location/locations/${filer_queryset}`,requestOptions)
      .then(res => res.json())
      .then(
          (data) => {
              let options = []
              data.results.map(destination => {
                  options.push({ label: destination.name, value: destination.id })
                })
             
                let DestinationGroup = [
                  { 
                      label: "Destination",
                      options: options
                  }
              ];
              this.setState({ DestinationGroup:DestinationGroup  })      
             
          },
          (error) => {
              console.log(error, 'error--------------') 
          }
      )  
 }

  async loadPlacesData(filer_queryset){
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
    };
    await fetch(`${BaseUrl}/api/locations/location/locations/${filer_queryset}`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
                let options = []
                data.results.map(place => {
                    options.push({ label: place.name, value: place.id })
                  })
              
                  let LocationGroup = [
                    { 
                        label: "Places",
                        options: options
                    }
                ];
                this.setState({ LocationGroup:LocationGroup  })      
              
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        )  
  } 

async loadPackageTypeData(){

  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
  };
  await fetch(`${BaseUrl}/api/vehicles/package_type/`,requestOptions)
      .then(res => res.json())
      .then(
          (data) => {
              let options = []
              const { prices} = this.state
                let selected_pkg = []
                for(let i=0; i<prices.length; i++){
                  selected_pkg.push(prices[i].package.id)
                }
              data.map(pkg => {
                  if(!selected_pkg.includes(pkg.id)){
                    let lable = pkg.nights === 0 ? `${pkg.days} Day` : `${pkg.days} Days - ${pkg.nights} Nights`
                    options.push({ label: lable, value: pkg.id })
                  }
                  
                })
                
                
                let PackageGroup = [
                  { 
                      label: "Packages",
                      options: options
                  }
              ];
              this.setState({ PackageGroup:PackageGroup  })      
             
          },
          (error) => {
              console.log(error, 'error--------------') 
          }
      )  
 }

  async loadBrandData(){

    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
    };
    await fetch(`${BaseUrl}/api/vehicles/brand/`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
                let options = []
                data.map(comp => {
                  options.push({ label: comp.name, value: comp.id })
                })
            
                let brandGroup = [
                  { 
                    label: "Brands",
                    options: options
                  }
                ];
                this.setState({ brandGroup: brandGroup                
                })           
              
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        )  
 }

 async loadVehicleTypeData(){

  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
  };
  await fetch(`${BaseUrl}/api/vehicles/vehicle_type/`,requestOptions)
      .then(res => res.json())
      .then(
          (data) => {
              let options = []
              data.map(comp => {
                options.push({ label: comp.name, value: comp.id })
              })
              let TypeGroup = [
                { 
                  label: "Vehical Type",
                  options: options
                }
              ];
              this.setState({ TypeGroup: TypeGroup, })           
            
          },
          (error) => {
              console.log(error, 'error--------------') 
          }
      )  
}

handleAcceptedFiles = files => {
  files.map(file =>
    Object.assign(file, {
      preview: URL.createObjectURL(file),
      formattedSize: this.formatBytes(file.size)
    })
  );
  this.setState({ selectedFiles: files });
};

handleRejectedFiles = files => {
  files.map(file =>
    Object.assign(file, {
      preview: URL.createObjectURL(file),
      formattedSize: this.formatBytes(file.size)
    })
  );
  this.setState({ rejectedFiles : files });
} 
/**
 * Formats the size
 */
formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

  onInputChange(e){
    this.loadDestinationData(`?parent=null&search=${e}`)
  }
  
  onPlaceInputChange(e){
    if (this.state.selectedDestination.value)
      this.loadPlacesData(`?parent__id=${this.state.selectedDestination.value}&search=${e}`)
  }
    
  handleselectedTypeGroup = selectedType =>{
      this.setState({ selectedType })
  }
  handleSelectedPackageGroup = SelectedPackage =>{
    this.setState({ SelectedPackage })
  }
  handleselectedFuelGroup = selectedFuel =>{
      this.setState({ selectedFuel })
  }

  handleSelectbrandGroup = selectedBrandsGroup => {
    this.setState({ selectedBrandsGroup });
  };

  handleSelectlocation = selectedLocation => {
    this.setState({ selectedLocation  })
  };
  handleSelectDestinationGroup = selectedDestination => {
    this.loadPlacesData(`?parent__id=${selectedDestination.value}`)
    this.setState({ selectedDestination, selectedLocation:{ label: "Select Place", value: false } });
  };

  handleAddImageNameSubmit(e, values){
    const { selected_img } = this.state
    if (selected_img){
      this.setState({imagenameloading:true})
    let data = {"name": values.name}
    const requestOptions = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
      body: JSON.stringify(data)
      };
      fetch(`${BaseUrl}/api/locations/location/images/${selected_img.id}/`,requestOptions)
      .then(res => 
          {if(res.status >= 400){
              res.json()
              .then(
                  (data) =>{  
                    console.log(data, "error data") 
                    this.setState({ model_img_name:false, imagenameloading:false })
                  }     
              )
          }
          else{
            this.loadData()
          }    
      }
    )

    }else{
      toastr.error("Somthing went wrong", "Please Try Again")
      this.setState({ model_img_name:false, imagenameloading:false })
    }
    

  }

  handleDefaultImage = item =>{
    this.setState({ gallery_loading:true })
    let data ={}
    data['name'] = item.name
    data['is_default'] = true
    const requestOptions = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
      body: JSON.stringify(data)
      };
      fetch(`${BaseUrl}/api/locations/location/images/${item.id}/`,requestOptions)
      .then(res => 
          {if(res.status >= 400){
              res.json()
              .then(
                  (data) =>{  
                    console.log(data, "error data")
                    toastr.error("Something Went Wrong", "") 
                    this.setState({ gallery_loading:false})
                  }     
              )
          }
          else{
         
                    const {default_image} = this.state
                    if (default_image){
                      let newdata ={}
                      newdata['name'] = default_image.name
                      newdata['is_default'] = false
                      const requestOptions = {
                        method: 'PUT',
                        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
                        body: JSON.stringify(newdata)
                        };
                        fetch(`${BaseUrl}/api/locations/location/images/${default_image.id}/`,requestOptions)
                        .then(res => 
                            {if(res.status >= 400){
                                res.json()
                                .then(
                                    (data) =>{  
                                      console.log(data, "error data") 
                                      this.setState({ gallery_loading:false})
                                    }     
                                )
                            }
                            else{
                                this.loadData()
                            }    
                        }
                      ) 

                    }else{
                      this.loadData()
                    }

                  } 
      }
    )
  } 


  handleImageDelete = id => {    
    const requestOptions = {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${this.obj.access}` },
    
        };
          fetch(`${BaseUrl}/api/locations/location/images/${id}/`,requestOptions)
                .then(res => 
                    {if(res.status >= 400){
                      console.log("error")
                    }
                    else{
                      this.loadData();
                      this.setState({
                        image_id:"",
                        success_confirm: true,
                        alert_confirm : false,
                        dynamic_title: "Deleted!",
                        gallery_loading: true,
                        dynamic_description: "Image has been deleted."
                        })
                        this.loadData()
                    }
                }
            )
    }

  handlePackegeTypeSubmit(e, values){
    this.setState({ packageloading: true })
    console.log(values)
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
      body: JSON.stringify(values)
      };
      fetch(`${BaseUrl}/api/vehicles/package_type/`,requestOptions)
            .then(res => 
                {if(res.status >= 400){
                    res.json()
                    .then(
                        (data) =>{  
                          toastr.error("Something Went Wrong", "") 
                          this.setState({ packageloading: false })
                        }
                          
                    )
                }
                else{
                    res.json()
                    .then(
                        (data) =>{
                        this.loadPackageTypeData()
                        this.setState({packageloading: false, model_package: false })
                        }
                    )
                }    
            }
        )
  }

  handlePackegeDelete = id => {    
    const requestOptions = {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${this.obj.access}` },
    
        };
          fetch(`${BaseUrl}/api/vehicles/package_price/${id}/`,requestOptions)
                .then(res => 
                    {if(res.status >= 400){
                      console.log("error")
                    }
                    else{
                      this.setState({
                        image_id:"",
                        package_success_confirm: true,
                        package_alert_confirm : false,
                        dynamic_title: "Deleted!",
                        dynamic_description: "Package Price has been deleted."
                        })
                        this.loadData()
                    }
                }
            )
    }

  handlePackegPriceSubmit(e, values){
    const {vehicle, SelectedPackage} = this.state
    if (SelectedPackage.value === "" ){
    toastr.error("Please Select Package", "")
    }else{
    this.setState({addpackagePriceloading:true})
    let new_data = {}
    new_data["vehicle"] = vehicle.id
    new_data["package"] = [SelectedPackage.value]
    new_data["price"] = [values.price]
    new_data["on_season_price"] = [values.on_season_price]
    axios.post(
    `${BaseUrl}/api/vehicles/package_price/`,
      new_data,
      {
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },                 
      }
      ).then(newres => {
        let SelectedPackage ={label: 'Select Package', value: ""}
        this.setState({SelectedPackage:SelectedPackage, addpackagePriceloading:false, model_addPackage:false})
        this.loadData()

      }).catch(err => {
        console.log(err, "----------------------error");
        toastr.error("Something Went Wrong", "")
        let SelectedPackage ={label: 'Select Package', value: ""}
        this.setState({SelectedPackage:SelectedPackage, model_addPackage:false ,addpackagePriceloading:false})
        })
    }
  }

  handleEditPackegePrice(selectedPrice){
    let selectedEditPackege = selectedPrice
    this.setState({selectedEditPackege})
    this.tog_editPackege()
  } 

  handleEditPackegeSubmit(e, values){
    this.setState({editPackageloading:true})
    const {selectedEditPackege} = this.state

    let new_data = {}
    new_data["vehicle"] = selectedEditPackege.vehicle
    new_data["package"] = selectedEditPackege.package.id
    new_data["price"] = values.price
    new_data["on_season_price"] = values.on_season_price
    axios.put(
    `${BaseUrl}/api/vehicles/package_price/${selectedEditPackege.id}/`,
      new_data,
      {
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },                    
      }
      ).then(newres => {
        this.setState({selectedEditPackege:[], editPackageloading:false, model_editPackage:false})
        this.loadData()

      }).catch(err => {
        console.log(err, "----------------------error");
        toastr.error("Something Went Wrong", "")
        this.setState({selectedEditPackege:[], model_editPackage:false ,editPackageloading:false})
        })
  }

  handleImageSubmit(e, values){
    if(this.state.selectedFiles.length === 0){

      toastr.error(`Select Images`,"") 
    }
    else{
        const { vehicle } = this.state
        this.setState({imagesloading:true})
        const formData = new FormData();
        const img = this.state.selectedFiles
        for(let i=0 ; i<img.length; i++){
          formData.append(
            "image",
            this.state.selectedFiles[i]
        );
        formData.append("name",values.image_name)
        axios.post(
          `${BaseUrl}/api/locations/images/`,
          formData,
          {
              headers: {
                  "Content-type": "multipart/form-data",
                  "Authorization": `Bearer ${this.obj.access}`
              },                    
          }
        )
        .then(res => {         
          let description = document.getElementById("textarea").value

          let images = []
          for(let i=0 ; i<vehicle.images.length; i++){
              images.push(vehicle.images[i].id)
            
          }
          for(let i=0 ; i<res.data.length; i++){
            images.push(res.data[i].id)
          
          }          
          let data = {}
          data["name"] = values.name
          data["model"] = values.model
          data["year"] = values.year
          data["fuel_type"] = this.state.selectedFuel.value
          data["vehicle_type"] = this.state.selectedType.value
          data["mileage"] = values.mileage
          data["seats"] = values.seates
          data["brand"] = this.state.selectedBrandsGroup.value
          data["location"] = this.state.selectedLocation.value
          data["ac"] =  document.getElementById("ac").checked
          data["heater"] =  document.getElementById("heater").checked
          data["passenger_airbag"] =  document.getElementById("airbags").checked
          data["number"] = values.number      
          data["driver_name"] = values.driver_name      
          data["mobile_no"] = values.mobile_no      
          data["agency"] = values.agency   
          data["agency_contact"] = values.agency_contact    
          data["address"] = values.address      
          data["zip_code"] = values.zip_code         
          data["description"] = description
          data['images'] = images
          const requestOptions = {
              method: 'PUT',
              headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
              body: JSON.stringify(data)
              };
              fetch(`${BaseUrl}/api/vehicles/vehicle/${vehicle.id}/`,requestOptions)
              .then(res => 
                  {if(res.status >= 400){
                      res.json()
                      .then(
                          (data) =>{  
                            console.log(data, "error data")
                            toastr.error("Something Went Wrong", "") 
                            this.setState({ imagesloading: false, model_images:false,selectedFiles:[]})
                          }     
                      )
                  }
                  else{
                      res.json()
                      .then(
                          (data) =>{
                            this.loadData()
                            toastr.success("Images Added", "") 
                            this.setState({ imagesloading: false, model_images:false, gallery_loading: true, selectedFiles:[]})
                          
                          }
                      )
                  }    
              }
            )
        })
        .catch(err => {
          toastr.error(`Somthing Went Wrong`,"") 
          this.setState({ imagesloading: false , model_images:false})
            console.log(err, "----------------------error");
          })

        }
    }
  }

  handleBrandSubmit(e, values) {
    this.setState({ brandloding: true })
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
        body: JSON.stringify(values)
        };
        fetch(`${BaseUrl}/api/vehicles/brand/`,requestOptions)
              .then(res => 
                  {if(res.status >= 400){
                      res.json()
                      .then(
                          (data) =>{  
                            console.log(data, "---data")
                            toastr.error("Something Went Wrong", "") 
                            this.setState({ brandloding: false })
                          }
                            
                      )
                  }
                  else{
                      res.json()
                      .then(
                          (data) =>{
                          let selectedBrandsGroup ={ label: data.name, value: data.id }
                          this.setState({brandloding: false, model_brand: false, selectedBrandsGroup:selectedBrandsGroup })
                          }
                      )
                  }    
              }
          )
  }

  handleVehicleTypeSubmit(e, values) {
    this.setState({ typeloading: true })
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
        body: JSON.stringify(values)
        };
        fetch(`${BaseUrl}/api/vehicles/vehicle_type/`,requestOptions)
              .then(res => 
                  {if(res.status >= 400){
                      res.json()
                      .then(
                          (data) =>{  
                            console.log(data, "---data")
                            toastr.error("Something Went Wrong", "") 
                            this.setState({ typeloading: false })
                          }     
                      )
                  }
                  else{
                      res.json()
                      .then(
                          (data) =>{
                          let selectedType ={ label: data.name, value: data.id }
                          this.setState({typeloading: false, model_type: false, selectedType:selectedType })
                          }
                      )
                  }    
              }
          )
  }

  handleSubmit(e, values) {
    let description = document.getElementById("textarea").value
    if(this.state.selectedLocation.value){
      this.setState({ loading: true })
      const { vehicle } = this.state
      let images = []
      for(let i=0 ; i<vehicle.images.length; i++){
          images.push(vehicle.images[i].id)
        
      }
      let data = {}
      data["name"] = values.name
      data["model"] = values.model
      data["year"] = values.year
      data["fuel_type"] = this.state.selectedFuel.value
      data["vehicle_type"] = this.state.selectedType.value
      data["mileage"] = values.mileage
      data["seats"] = values.seates
      data["brand"] = this.state.selectedBrandsGroup.value
      data["place"] = this.state.selectedLocation.value
      data["destination"] = this.state.selectedDestination.value
      data["ac"] =  document.getElementById("ac").checked
      data["heater"] =  document.getElementById("heater").checked
      data["passenger_airbag"] =  document.getElementById("airbags").checked
      data["number"] = values.number      
      data["driver_name"] = values.driver_name      
      data["mobile_no"] = values.mobile_no      
      data["agency"] = values.agency   
      data["agency_contact"] = values.agency_contact    
      data["address"] = values.address      
      data["zip_code"] = values.zip_code      
      // data["per_day_price"] = values.per_day_price           
      data["description"] = description
      data['images'] = images
      const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
        body: JSON.stringify(data)
        };
        fetch(`${BaseUrl}/api/vehicles/vehicle/${vehicle.id}/`,requestOptions)
              .then(res => 
                  {if(res.status >= 400){
                      res.json()
                      .then(
                          (data) =>{  
                              console.log(data, "error data")
                            toastr.error("Something Went Wrong", "") 
                            this.setState({ loading: false })
                          }     
                      )
                  }
                  else{
                      res.json()
                      .then(
                          (data) =>{
                              this.props.history.push(`/vehicle/${data.id}`)
                          
                          }
                      )
                  }    
              }
          )  
    }else{
      toastr.error("Select Place", "") 
    }
  }

  render() {
    const { TypeGroup, selectedBrandsGroup, brandGroup, selectedType, 
            selectedFuel,LocationGroup, selectedLocation, vehicle, selectedDestination, DestinationGroup, prices, PackageGroup } = this.state;

    const CustomMenu = ({ innerRef, innerProps, isDisabled, children }) =>
        !isDisabled ? (
            <div id="add_state" ref={innerRef} {...innerProps} className="customReactSelectMenu">
                {children}
                <Link to="#" onClick={this.tog_center}  className="text-warning"><i className="mdi mdi-plus font-size-18"></i></Link>

            </div>
        ) : null;
    const VehicleType = ({ innerRef, innerProps, isDisabled, children }) =>
      !isDisabled ? (
          <div id="add_type" ref={innerRef} {...innerProps} classNamePrefix="customReactSelectMenu">
              {children}
              <Link to="#" onClick={this.tog_type}  className="text-warning"><i className="mdi mdi-plus font-size-18"></i></Link>
          </div>
      ) : null;

      const PackageType = ({ innerRef, innerProps, isDisabled, children }) =>
      !isDisabled ? (
          <div id="add_type" ref={innerRef} {...innerProps} classNamePrefix="customReactSelectMenu">
              {children}
              <Link to="#" onClick={this.tog_package}  className="text-warning"><i className="mdi mdi-plus font-size-18"></i></Link>
          </div>
      ) : null;


    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs title="" breadcrumbItems={this.state.breadcrumbItems} />
            {!isEmpty(vehicle)?
              <>
                <AvForm className="needs-validation" onValidSubmit={this.handleSubmit} >
                  <Row>
                    <Col xl="6">
                      <Card>
                        <CardBody> 
                          <h4 className="card-title">Vehicle Detail</h4>
                          <Row>
                                <Col md="6">
                                    <div className="mb-3">
                                        <Label className="form-label">Brand</Label>
                                        <Select 
                                            value={selectedBrandsGroup}
                                            onChange={this.handleSelectbrandGroup}
                                            options={brandGroup}
                                            components={{ Menu: CustomMenu }}
                                            classNamePrefix="select2-selection"
                                        />

                                    </div>
                                </Col>
                                <Col md="6">
                                <div className="mb-3">
                                  <Label className="form-label " htmlFor="name">Vehicle Name</Label>
                                  <AvField
                                    name="name"
                                    placeholder="Vehicle Name"
                                    type="text"
                                    value={vehicle.name}
                                    errorMessage="Enter Vehicle Name"
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    id="name"
                                    
                                  />
                                </div>
                              </Col> 
                            </Row>
                            <Row>
                              
                              <Col md="6">
                                <div className="mb-3">
                                  <Label className="form-label " htmlFor="model">Vehicle Model</Label>
                                  <AvField
                                    name="model"
                                    placeholder="Vehicle Model"
                                    type="text"
                                    value={vehicle.model}
                                    errorMessage="Enter Vehicle Model"
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    id="model"
                                    
                                  />
                                </div>
                              </Col>
                              <Col md="6">
                                <div className="mb-3">
                                  <Label className="form-label " htmlFor="seates">Model Year</Label>
                                  <AvField
                                    name="year"
                                    placeholder="Model Year"
                                    type="number"
                                    value={vehicle.year}
                                    className="form-control"
                                    errorMessage="Enter Only Number"
                                    validate={{
                                      required: { value: true },
                                        pattern: {
                                        value: "^[0-9]+$",
                                        errorMessage: "Only Numbers"
                                        }
                                    }}
                                    id="seates"
                                    
                                  />
                                </div>
                              </Col>                      
                            </Row>

                            <Row>
                              <Col md="6">
                                <div className="mb-3">
                                    <Label className="form-label">Vehicle Type</Label>
                                    <Select 
                                    value={selectedType}
                                    onChange={this.handleselectedTypeGroup}
                                    options={TypeGroup}
                                    components={{ Menu: VehicleType }}
                                    classNamePrefix="select2-selection"
                                    />

                                </div>
                              </Col>
                              <Col md="6">
                                <div className="mb-3">
                                    <Label className="form-label">Fuel</Label>
                                    <Select 
                                    value={selectedFuel}
                                    onChange={this.handleselectedFuelGroup}
                                    options={FuelGroup}
                                    classNamePrefix="select2-selection"
                                    />

                                </div>
                              </Col>
                            </Row>

                            <Row>
                              <Col md="6">
                                <div className="mb-3">
                                  <Label className="form-label " htmlFor="seates">No of Seates</Label>
                                  <AvField
                                    name="seates"
                                    placeholder="No of Seates"
                                    type="number"
                                    value={vehicle.seats}
                                    className="form-control"
                                    errorMessage="Enter Only Number"
                                    validate={{
                                      required: { value: true },
                                        pattern: {
                                        value: "^[0-9]+$",
                                        errorMessage: "Only Numbers"
                                        }
                                    }}
                                    id="seates"
                                  />
                                </div>
                              </Col> 
                              
                              <Col md="6">
                                <div className="mb-3">
                                  <Label className="form-label " htmlFor="mileage">Mileage (km/litre)</Label>
                                  <AvField
                                    name="mileage"
                                    placeholder="Mileage (km/litre)"
                                    type="text"
                                    value={vehicle.mileage}
                                    errorMessage="Enter Vehicle Mileage"
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    id="mileage"
                                    
                                  />
                                </div>
                              </Col> 
                              
                            </Row>
                            <Row>
                              <Col md="6">
                                  <div className="mb-3">
                                    <Label className="form-label " htmlFor="number">Vehicle Number</Label>
                                    <AvField
                                      name="number"
                                      placeholder="Vehicle Number"
                                      type="text"
                                      value={vehicle.number}
                                      errorMessage="Enter Vehicle Number"
                                      className="form-control"
                                      validate={{ required: { value: true } }}
                                      id="number"
                                      
                                    />
                                  </div>
                                </Col>
                            </Row>
                        
                            <Row>
                              <Col md={4} className="mt-3">                      
                                  <div className="form-check mb-3">
                                      <Input className="form-check-input" type="checkbox" defaultChecked={vehicle.ac} id="ac" />
                                      <Label className="form-check-label" htmlFor="ac">
                                          AC
                                      </Label>
                                  </div>                 
                              </Col>
                              <Col md={4} className="mt-3">                         
                                  <div className="form-check mb-3">
                                      <Input className="form-check-input" type="checkbox" defaultChecked={vehicle.heater} id="heater" />
                                      <Label className="form-check-label" htmlFor="heater">
                                      Heater
                                      </Label>
                                  </div>                   
                              </Col>
                              <Col md={4} className="mt-3">                         
                                  <div className="form-check mb-3">
                                      <Input className="form-check-input" type="checkbox" defaultChecked={vehicle.passenger_airbag} id="airbags" />
                                      <Label className="form-check-label" htmlFor="airbags">
                                          Passenger Airbags
                                      </Label>
                                  </div>                   
                              </Col>
                            </Row>
                            <Row>
                              <div className="mb-3">
                                <Label className="form-label " htmlFor="price">Description</Label>
                                  <Input
                                    type="textarea"
                                    id="textarea"
                                    defaultValue={vehicle.description}
                                    rows="3"
                                    placeholder="About Vehicle"
                                  />
                              </div>
                            </Row>      
                        </CardBody>
                      </Card>
                    </Col>
                    <Col xl="6">
                      <Card>
                        <CardBody> 
                          <h4 className="card-title">Additional Detail</h4>
                            <Row>
                              
                            <Col md="6">
                                <div className="mb-3">
                                  <Label className="form-label " htmlFor="driver_name">Driver Name</Label>
                                  <AvField
                                    name="driver_name"
                                    placeholder="Driver Name"
                                    type="text"
                                    value={vehicle.driver_name}
                                    errorMessage="Enter Driver Name"
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    id="driver_name"
                                    
                                  />
                                </div>
                              </Col> 
                              <Col md="6">
                                <div className="mb-3">
                                <Label className="form-label " htmlFor="mobile_no">Driver Contact Number</Label>
                                  <AvField
                                    name="mobile_no"
                                    placeholder="Driver Contact Number"
                                    type="number"
                                    value={vehicle.mobile_no}
                                    className="form-control"
                                    errorMessage="Enter Only Number"
                                    validate={{
                                      required: { value: true },
                                        pattern: {
                                        value: "^[0-9]+$",
                                        errorMessage: "Only Numbers"
                                        }
                                    }}
                                    id="mobile_no"
                                    
                                  />
                                </div>
                              </Col> 
                            </Row>
                            <Row>
                              <Col md="6">
                                  <div className="mb-3">
                                    <Label className="form-label " htmlFor="agency">Agency Name</Label>
                                    <AvField
                                      name="agency"
                                      placeholder="Agency Name"
                                      type="text"
                                      value={vehicle.agency}
                                      errorMessage="Enter Agency Name"
                                      className="form-control"
                                      validate={{ required: { value: true } }}
                                      id="agency"
                                      
                                    />
                                  </div>
                              </Col> 
                              <Col md="6">
                                <div className="mb-3">
                                  <Label className="form-label " htmlFor="agency_contact">Agency Contact Number</Label>
                                    <AvField
                                      name="agency_contact"
                                      placeholder="Agency Contact Number"
                                      type="number"
                                      value={vehicle.agency_contact}
                                      className="form-control"
                                      errorMessage="Enter Only Number"
                                      validate={{
                                        required: { value: true },
                                          pattern: {
                                          value: "^[0-9]+$",
                                          errorMessage: "Only Numbers"
                                          }
                                      }}
                                      id="agency_contact"
                                      
                                    />
                                  </div>
                              </Col> 
                            </Row> 
                            <Row>
                              <Col md="12">
                                    <div className="mb-3">
                                      <Label className="form-label " htmlFor="address">Address</Label>
                                      <AvField
                                        name="address"
                                        placeholder="Agency Address"
                                        type="text"
                                        value={vehicle.address}
                                        errorMessage="Enter Agency Address"
                                        className="form-control"
                                        validate={{ required: { value: true } }}
                                        id="address"
                                        
                                      />
                                    </div>
                                </Col> 

                            </Row>
                            <Row>
                              <Col md="6">
                                <div className="mb-3">
                                    <Label className="form-label">Destination</Label>
                                    <Select 
                                    onInputChange={this.onInputChange}
                                    value={selectedDestination}
                                    onChange={this.handleSelectDestinationGroup}
                                    options={DestinationGroup}
                                    classNamePrefix="select2-selection"
                                    />
                              </div>
                              </Col>
                              <Col md="6">
                                  <div className="mb-3">
                                      <Label className="form-label">Place</Label>
                                      <Select 
                                      onInputChange={this.onPlaceInputChange}
                                      value={selectedLocation}
                                      onChange={this.handleSelectlocation}
                                      options={LocationGroup}
                                      classNamePrefix="select2-selection"
                                      />
                                  </div>
                                  
                              </Col>
                            </Row>
                            <Row>
                              <Col md="6">
                                <div className="mb-3">
                                  <AvField
                                    name="zip_code"
                                    label="Pin Code"
                                    placeholder="Enter Only number"
                                    type="number"
                                    value={vehicle.zip_code}
                                    errorMessage="Enter Only Number"
                                    validate={{
                                      required: { value: true },
                                      
                                      maxLength: {
                                        value: 6,
                                        errorMessage: "Numbers must be less than 7 digit"},
                                      minLength: {
                                        value: 6,
                                        errorMessage: "Numbers must be Grater than 5 digit"}   
                                    }}
                                  />
                                </div>
                              </Col> 
                              
                            </Row>

                                    
                            <FormGroup className="mb-0">
                              {this.state.loading?(
                                <Spinner className="me-2 mt-2" color="primary" />
                              ):(
                                <div>
                            
                              <Button type="submit" color="primary" className="me-1">
                                Submit
                            </Button>{" "}
                              <Button type="button" onClick={() => this.props.history.goBack()} color="secondary">
                                Cancel
                            </Button>
                            </div>
                              )}
                          </FormGroup>      

                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                  
                </AvForm>
                <Row>
                  <Col xl="6">                        
                    <Card>
                        <CardBody> 
                        <h4 className="card-title">Gallery</h4>
                        {this.state.gallery_loading?
                        <div className="d-flex align-items-center justify-content-center m-5">
                          <Spinner className="me-2 mt-2" color="primary" />
                        </div>
                          :
                          <>
                            <div className="table-responsive">
                              <Table className="table-nowrap mb-0">
                                <tbody>
                                  <tr key={'GalleryHeading'}>
                                    <th
                                    scope="row"
                                    >
                                    {"Image"}
                                    </th>
                                    <th
                                    scope="row"
                                    >
                                    {"Name"}
                                    </th>
                                    <th
                                    scope="row"
                                    >
                                    {"Default"}
                                    </th>
                                    <th
                                    scope="row"
                                    >
                                    {"Action"}
                                    </th>
                                    </tr> 
                                    {vehicle.images.map((item, i) => (
                                      <tr key={i+"image"}>
                                        <th
                                        scope="row"
                                        >
                                        <img className="rounded avatar-md" alt="image" src={BaseUrl+item.image} />
                                        </th>
                                        <th
                                        scope="row"
                                        >
                                        <p>{item.name}</p>
                                        </th>
                                        <th
                                        scope="row"
                                        >
                                          {item.is_default?
                                            
                                              <Input className="form-check-input m-2" type="radio" onChange={() =>this.handleDefaultImage(item)} name="exampleRadios" id={item.id} value={item.id} defaultChecked />
                                  
                                            :
                                    
                                              <Input className="form-check-input m-2" type="radio" onChange={() =>this.handleDefaultImage(item)} name="exampleRadios" id={item.id} value={item.id} />
                                                                              
                                          }
                                        </th>
                                        <th
                                        scope="row"
                                        >
                                          <Link to="#" onClick={() => this.setState({ selected_img: item, model_img_name:true })}  className="text-danger me-3"><i className="mdi mdi-pencil font-size-18"></i></Link>
                                          <Link to="#" onClick={() => this.setState({ alert_confirm: true, image_id:item.id })}  className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>
                                        </th>
                                      </tr> 
                                    ))}
                              </tbody>
                              </Table>
                            </div>
                            <Button type="button" className="btn-sm mt-4" onClick={this.tog_images} color="info"><i className=" fas fa-plus"></i></Button>
                          </>}
                        </CardBody>
                    </Card>

                  </Col>
                  <Col xl="6">                        
                    <Card>
                      <CardBody> 
                        <h4 className="card-title">Package Pricing</h4>
                        
                        <div className="table-responsive">
                                <Table className="table-nowrap mb-0">
                                    <tbody>
                                    <tr key={'Distances'}>
                                    <th
                                    scope="row"
                                    >
                                    {"Package"}
                                    </th>
                                    <th
                                    scope="row"
                                    >
                                    {"Off Season Price"}
                                    </th>
                                    <th
                                    scope="row"
                                    >
                                    {"On Season Price"}
                                    </th>
                                    <th
                                    scope="row"
                                    >
                                    {"Action"}
                                    </th>
                                </tr> 
                                {prices.map((price, i) => (
                                    <tr key={i+price.id}>
                                    <th
                                    scope="row"
                                    >
                                    {price.package.nights === 0 ? `${price.package.days} Day` : `${price.package.days} Days - ${price.package.nights} Nights`}
                                    </th>
                                    <th
                                    scope="row"
                                    >
                                    ₹ {price.price}
                                    </th>
                                    <th
                                    scope="row"
                                    >
                                    ₹ {price.on_season_price}
                                    </th>
                                    <th
                                    scope="row"
                                    >
                                    <Link to="#" onClick={() => this.handleEditPackegePrice(price)}  className="text-primary"><i className="mdi mdi-pencil font-size-18"></i></Link>
                                    <Link to="#" onClick={() => this.setState({ package_alert_confirm: true, package_id:price.id })}  className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>
                                    </th>
                                </tr> 
                                ))}
                                


                                    </tbody>
                                </Table>
                        </div>
                        <Button type="button" className="btn-sm mt-4" onClick={this.tog_addPackege} color="info"><i className=" fas fa-plus"></i></Button>
                        
                      </CardBody>
                    </Card>

                  </Col>
                </Row>
                <ActivityLog
                  vehicle ={this.state.vehicle}
                  user = {this.obj.user}
                  access = {this.obj.access}
                  history = {this.props.history}
              /> 
              </>
              :
                <div className="d-flex align-items-center justify-content-center min-vh-100">
            
                    <Spinner type="grow" className="me-2" color="secondary" />
                    <Spinner type="grow" className="me-2" color="secondary" />
                    <Spinner type="grow" className="me-2" color="secondary" />
                    <Spinner type="grow" className="me-2" color="secondary" />
            
                </div>}
            {/* Models for Add Brand and Vehicle Types */}
            <Row>
              <Col sm={6} md={4} xl={3} className="mt-4">
               
                <Modal
                  isOpen={this.state.model_brand}
                  toggle={this.tog_center}
                  centered={true}
                >
                  <ModalHeader toggle={() => this.setState({ model_brand: false })}>
                  Add Brand
                  </ModalHeader>
                  <ModalBody>
                    <AvForm className="needs-validation" onValidSubmit={this.handleBrandSubmit} >
            
                      <Row>
                        <Col md="6">
                          <div className="mb-3">
                            <Label className="form-label " htmlFor="name">Brand Name</Label>
                            <AvField
                              name="name"
                              placeholder="Brand Name"
                              type="text"
                              errorMessage="Enter Brand Name"
                              className="form-control"
                              validate={{ required: { value: true } }}
                              id="name"
                              
                            />
                          </div>
                        </Col> 
                      </Row>
                                        
                      <FormGroup className="mb-0">
                        {this.state.brandloding?(
                          <Spinner className="me-2 mt-2" color="primary" />
                        ):(
                          <div>
                      
                        <Button type="submit" color="primary" className="me-1">
                          Submit
                        </Button>
                        </div>
                          )}
                      </FormGroup>     
                    </AvForm>

                  </ModalBody>
                </Modal>
              </Col>
              {/* Model Change Image name */}
              <Col sm={6} md={4} xl={3} className="mt-4">
               
               <Modal
                 isOpen={this.state.model_img_name}
                 toggle={this.tog_img_name}
                 centered={true}
               >
                 <ModalHeader toggle={this.tog_img_name}>
                 Change Image Name
                 </ModalHeader>
                 <ModalBody>
                   <AvForm className="needs-validation" onValidSubmit={this.handleAddImageNameSubmit} >
                     <Row>
                       <Col md="8">
                         <div className="mb-3">
                           <Label className="form-label " htmlFor="img_name">Name</Label>
                           <AvField
                             name="name"
                             placeholder="Name"
                             type="text"
                             value={this.state.selected_img?.name}
                             errorMessage="Enter Name"
                             className="form-control"
                             validate={{ required: { value: true } }}
                             id="img_name"
                           />
                         </div>
                       </Col> 
                     </Row>
                                       
                     <FormGroup className="mb-0">
                       {this.state.imagenameloading?(
                         <Spinner className="me-2 mt-2" color="primary" />
                       ):(
                         <div>
                     
                       <Button type="submit" color="primary" className="me-1">
                         Save
                       </Button>
                       </div>
                         )}
                     </FormGroup>     
                   </AvForm>

                 </ModalBody>
               </Modal>
             </Col>
              {/* Add Vehicle Price */}
              <Col sm={6} md={4} xl={3} className="mt-4">
               
               <Modal
                 isOpen={this.state.model_type}
                 toggle={this.tog_type}
                 centered={true}
               >
                 <ModalHeader toggle={() => this.setState({ model_type: false })}>
                 Add Vehicle Type
                 </ModalHeader>
                 <ModalBody>
                   <AvForm className="needs-validation" onValidSubmit={this.handleVehicleTypeSubmit} >
           
                     <Row>
                       <Col md="6">
                         <div className="mb-3">
                           <Label className="form-label " htmlFor="name"> Name</Label>
                           <AvField
                             name="name"
                             placeholder="Vehicle Type"
                             type="text"
                             errorMessage="Enter Vehicle Type"
                             className="form-control"
                             validate={{ required: { value: true } }}
                             id="name"
                             
                           />
                         </div>
                       </Col> 
                     </Row>
                                       
                     <FormGroup className="mb-0">
                       {this.state.typeloading?(
                         <Spinner className="me-2 mt-2" color="primary" />
                       ):(
                         <div>
                     
                       <Button type="submit" color="primary" className="me-1">
                         Submit
                       </Button>
                       </div>
                         )}
                     </FormGroup>     
                   </AvForm>

                 </ModalBody>
               </Modal>
             </Col>
             {/* Model Add Images */}
             <Col sm={6} md={4} xl={3} className="mt-4">
               
               <Modal
                 isOpen={this.state.model_images}
                 toggle={this.tog_images}
                 centered={true}
               >
                 <ModalHeader toggle={() => this.setState({ model_images: false, selectedFiles: [] })}>
                 Add Images
                 </ModalHeader>
                 <ModalBody>
                   <AvForm className="needs-validation" onValidSubmit={this.handleImageSubmit} >
                    <Row>
                        <Col md="12">
                            <div className="mb-3">
                            <Label className="form-label " htmlFor="image_name">Name</Label>
                            <AvField
                                name="image_name"
                                placeholder="Name"
                                type="text"
                                errorMessage="Enter Name"
                                className="form-control"
                                validate={{ required: { value: true } }}
                                id="image_name" 
                            />
                            </div>
                        </Col> 
                      </Row>
                      <Row>
                         <Col md="12">
                           <Dropzone
                              accept='.jpeg,.jpg,.JPG,.JPEG,.PNG,.png'
                              maxSize={1000000}
                              onDrop = {(acceptedFiles, fileRejections) => {
                                this.handleRejectedFiles(fileRejections)
                                this.handleAcceptedFiles(acceptedFiles)
                                }}
                            >
                              {({ getRootProps, getInputProps }) => (
                              <div className="dropzone">
                                <div
                                  className="dz-message needsclick"
                                  {...getRootProps()}
                                  >
                                  <input {...getInputProps()} />
                                  <div className="mb-3">
                                      <i className="display-4 text-muted ri-upload-cloud-2-line"></i>
                                  </div>
                                  <h6>Drop only .jpeg/.png Images here or click to upload.</h6>
                                  <h6>Images size is less than 1 MB.</h6>
                                </div>
                              </div>
                              )}
                            </Dropzone>
                               <div
                                   className="dropzone-previews mt-3"
                                   id="file-previews"
                               >
                                   {this.state.selectedFiles.map((f, i) => {
                                   return (
                                       <Card
                                       className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                       key={i + "-file"}
                                       >
                                       <div className="p-2">
                                           <Row className="align-items-center">
                                           <Col className="col-auto">
                                               <img
                                               data-dz-thumbnail=""
                                               height="80"
                                               className="avatar-sm rounded bg-light"
                                               alt={f.name}
                                               src={f.preview}
                                               />
                                           </Col>
                                           <Col>
                                               <Link
                                               to="#"
                                               className="text-muted fw-bold"
                                               >
                                               {f.name}
                                               </Link>
                                               <p className="mb-0">
                                               <strong>{f.formattedSize}</strong>
                                               </p>
                                           </Col>
                                           </Row>
                                       </div>
                                       </Card>
                                   );
                                   })}
                            {this.state.rejectedFiles.length > 0?
                                <>
                                  <hr></hr>
                                  <p style={{ color: "red", padding: 5, margin: 0, fontSize: 14 }}>
                                    {"Rejected Files: File size is grater than 1 MB or Invalid File Format"}
                                  </p>
                                </>
                              :""}
                               {this.state.rejectedFiles.map((f, i) => {
                            return (
                                <Card
                                className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                key={i + "-rejected_file"}
                                >
                                <div className="p-2">
                                    <Row className="align-items-center">
                                    <Col className="col-auto">
                                        <img
                                        data-dz-thumbnail=""
                                        height="80"
                                        className="avatar-sm rounded bg-light"
                                        alt={f.name}
                                        src={f.preview}
                                        />
                                    </Col>
                                    <Col>
                                        <Link
                                        to="#"
                                        className="text-muted fw-bold"
                                        >
                                        {f.name}
                                        </Link>
                                        <p className="mb-0">
                                        <strong>{f.formattedSize}</strong>
                                        </p>
                                    </Col>
                                    </Row>
                                </div>
                                </Card>
                              );
                              })}
                               </div>
                         </Col>
                       </Row> 
           
                     
                                       
                     <FormGroup className="mb-0">
                       {this.state.imagesloading?(
                         <Spinner className="me-2 mt-2" color="primary" />
                       ):(
                         <div>
                     
                       <Button type="submit" color="primary" className="me-1">
                         Submit
                       </Button>
                       </div>
                         )}
                     </FormGroup>     
                   </AvForm>

                 </ModalBody>
               </Modal>
             </Col>
              {/* Edit Packege Group */}
              <Col sm={6} md={4} xl={3} className="mt-4">
               
               <Modal
                  isOpen={this.state.model_editPackage}
                  toggle={this.tog_editPackege}
                  centered={true}
                >
                  <ModalHeader toggle={() => this.setState({ model_editPackage: false })}>
                  Edit {this.state.selectedEditPackege.package?
                  (this.state.selectedEditPackege.package.nights === 0 ? `${this.state.selectedEditPackege.package.days} Day` : `${this.state.selectedEditPackege.package.days} Days - ${this.state.selectedEditPackege.package.nights} Nights`)
                  :""} Package Price
                  </ModalHeader>
                  <ModalBody>
                    <AvForm className="needs-validation" onValidSubmit={this.handleEditPackegeSubmit} >
                                <Row>
                                 <Col md="12">
                                     <div className="mb-3">
                                       <Label className="form-label" htmlFor={"price"}>Off Season Price</Label>
                                       <AvField
                                         name="price"
                                         placeholder="Price"
                                         type="text"
                                         className="form-control"
                                         value={this.state.selectedEditPackege.price}
                                         validate={{ required: { value: true } }}
                                         id={"price"} 
                                       />
                                     </div>
                                   </Col> 
                               </Row>  
                               <Row>
                                 <Col md="12">
                                     <div className="mb-3">
                                       <Label className="form-label" htmlFor={"on_season_price"}>On Season Price</Label>
                                       <AvField
                                         name="on_season_price"
                                         placeholder="Price"
                                         type="text"
                                         className="form-control"
                                         value={this.state.selectedEditPackege.on_season_price}
                                         validate={{ required: { value: true } }}
                                         id={"on_season_price"} 
                                       />
                                     </div>
                                   </Col> 
                               </Row>                          
                      <FormGroup className="mb-0 mt-2">
                        {this.state.editPackageloading?(
                          <Spinner className="me-2 mt-2" color="primary" />
                        ):(
                       <div>
                      
                        <Button type="submit" color="primary" className="me-1">
                          Submit
                        </Button>
                        </div>
                          )}
                      </FormGroup>     
                    </AvForm>
 
                  </ModalBody>
                </Modal>
              </Col>
              {/* Add Packege Group */}
              <Col sm={6} md={4} xl={3} className="mt-4">
               
               <Modal
                  isOpen={this.state.model_addPackage}
                  toggle={this.tog_addPackege}
                  centered={true}
                >
                  <ModalHeader toggle={() => this.setState({ model_addPackage: false, SelectedPackage:{label: 'Select Package', value: ""} })}>
                  Add New Package Price 
                  </ModalHeader>
                  <ModalBody>
                    <AvForm className="needs-validation" onValidSubmit={this.handlePackegPriceSubmit} >
                               <Row>
                                 <Col md="12">
                                   <div className="mb-3">
                                       <Label className="form-label">Package </Label>
                                        <Select 
                                          value={this.state.SelectedPackage}
                                          onChange={this.handleSelectedPackageGroup}
                                          options={PackageGroup}
                                          components={{ Menu: PackageType }}
                                          classNamePrefix="select2-selection"
                                       />
                                   </div>
                                 </Col>
                                </Row>
                                <Row>
                                 <Col md="12">
                                     <div className="mb-3">
                                       <Label className="form-label" htmlFor={"price"}>Off season Price</Label>
                                       <AvField
                                         name="price"
                                         placeholder="Off season Price"
                                         type="text"
                                         className="form-control"
                                         validate={{ required: { value: true } }}
                                         id={"price"} 
                                       />
                                     </div>
                                   </Col> 
                               </Row>        
                               <Row>
                                 <Col md="12">
                                     <div className="mb-3">
                                       <Label className="form-label" htmlFor={"on_season_price"}>On season Price</Label>
                                       <AvField
                                         name="on_season_price"
                                         placeholder="On season Price"
                                         type="text"
                                         className="form-control"
                                         validate={{ required: { value: true } }}
                                         id={"on_season_price"} 
                                       />
                                     </div>
                                   </Col> 
                               </Row>                
                      <FormGroup className="mb-0 mt-2">
                        {this.state.addpackagePriceloading?(
                          <Spinner className="me-2 mt-2" color="primary" />
                        ):(
                       <div>
                      
                        <Button type="submit" color="primary" className="me-1">
                          Submit
                        </Button>
                        </div>
                          )}
                      </FormGroup>     
                    </AvForm>
 
                  </ModalBody>
                </Modal>
              </Col>
                           {/* Add Packeges  */}
             <Col sm={6} md={4} xl={3} className="mt-4">
               
               <Modal
                 isOpen={this.state.model_package}
                 toggle={this.tog_package}
                 centered={true}
               >
                 <ModalHeader toggle={() => this.setState({ model_package: false })}>
                 Add Package Type
                 </ModalHeader>
                 <ModalBody>
                   <AvForm className="needs-validation" onValidSubmit={this.handlePackegeTypeSubmit} >
           
                   <Row>
                       <Col md="6">
                         <div className="mb-3">
                           <Label className="form-label" htmlFor="days"> Day</Label>
                           <AvField
                                name="days"
                                placeholder="Days"
                                type="number"
                                className="form-control"
                                errorMessage="Enter Only Number"
                                validate={{
                                  required: { value: true },
                                    pattern: {
                                    value: "^[0-9]+$",
                                    errorMessage: "Only Numbers"
                                    }
                                }}
                                id="days"
                              />
                         </div>
                       </Col>
                       <Col md="6">
                         <div className="mb-3">
                           <Label className="form-label" htmlFor="nights">Nights</Label>
                           <AvField
                                name="nights"
                                placeholder="Nights"
                                type="number"
                                className="form-control"
                                errorMessage="Enter Only Number"
                                validate={{
                                  required: { value: true },
                                    pattern: {
                                    value: "^[0-9]+$",
                                    errorMessage: "Only Numbers"
                                    }
                                }}
                                id="nights"
                              />
                         </div>
                       </Col>
                     </Row>
                                       
                     <FormGroup className="mb-0">
                       {this.state.packageloading?(
                         <Spinner className="me-2 mt-2" color="primary" />
                       ):(
                         <div>
                     
                       <Button type="submit" color="primary" className="me-1">
                         Submit
                       </Button>
                       </div>
                         )}
                     </FormGroup>     
                   </AvForm>

                 </ModalBody>
               </Modal>
             </Col>
            </Row>
            {/* End Model  */}
            {/* Alert */}
            {this.state.alert_confirm ? (
                <SweetAlert
                title="Are you sure?"
                warning
                showCancel
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="danger"
                onConfirm={() => this.handleImageDelete(this.state.image_id)}
                onCancel={() =>
                    this.setState({
                        alert_confirm: false,
                        image_id:"",

                    })
                }
                >
                You won't be able to revert this!
                </SweetAlert>
              ) : null}

            {this.state.success_confirm ? (
                <SweetAlert
                success
                title={this.state.dynamic_title}
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="danger"
                onConfirm={() => this.setState({ success_confirm: false, alert_confirm : false })}
                >
                    {this.state.dynamic_description}
                </SweetAlert>
              )
              : null}
              {/* Handle Packege Price */}
                {this.state.package_alert_confirm ? (
                  <SweetAlert
                  title="Are you sure?"
                  warning
                  showCancel
                  confirmBtnBsStyle="success"
                  cancelBtnBsStyle="danger"
                  onConfirm={() => this.handlePackegeDelete(this.state.package_id)}
                  onCancel={() =>
                      this.setState({
                        package_alert_confirm: false,
                        package_id:"",

                      })
                  }
                  >
                  You won't be able to revert this!
                  </SweetAlert>
                ) : null}

              {this.state.package_success_confirm ? (
                  <SweetAlert
                  success
                  title={this.state.dynamic_title}
                  confirmBtnBsStyle="success"
                  cancelBtnBsStyle="danger"
                  onConfirm={() => this.setState({ package_success_confirm: false, package_alert_confirm : false })}
                  >
                      {this.state.dynamic_description}
                  </SweetAlert>
                )
                : null}

          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default EditVehicles;



    